import { render, staticRenderFns } from "./Reauthorize.vue?vue&type=template&id=74283273&scoped=true&"
import script from "./Reauthorize.vue?vue&type=script&lang=js&"
export * from "./Reauthorize.vue?vue&type=script&lang=js&"
import style0 from "./Reauthorize.vue?vue&type=style&index=0&id=74283273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74283273",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74283273')) {
      api.createRecord('74283273', component.options)
    } else {
      api.reload('74283273', component.options)
    }
    module.hot.accept("./Reauthorize.vue?vue&type=template&id=74283273&scoped=true&", function () {
      api.rerender('74283273', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/facebook/Reauthorize.vue"
export default component.exports